// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__hywY5","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__14BAm"};